import { render, staticRenderFns } from "./Powered.vue?vue&type=template&id=2de2bdd4&lang=true"
import script from "./Powered.vue?vue&type=script&lang=js"
export * from "./Powered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports